import { socket } from '../..';
import { agentTestEvents } from '@shared/services/agent-test';

export const handleAgentTestFieldsChanged = () => {
  return socket.onMessage('AGENT_TEST_FIELDS_CHANGED', (payload) => {
    agentTestEvents.emitFieldsChanged(payload);
  });
};
